import { PureComponent } from 'react';

import { featureAvailable } from '../services/features-service';

export default class FeatureAvailable extends PureComponent {
    render() {
        if (featureAvailable(this.props.type, this.props.customList) && !this.props.reverse) {
            return this.props.children;
        }
        if (!featureAvailable(this.props.type, this.props.customList) && this.props.reverse) {
            return this.props.children;
        }

        return null;
    }
}
